import i18n from '@/lang/i18n'
import { ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-community/core'
import { Nullable } from '@/shared/types/app.types'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { preformattedGridConfigurationServices } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.service'
import { store } from '@/store/store'

export const columnsDefTextPreformattedGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.preformated'),
            field: 'title',
            minWidth: 400,
            flex: 2,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            flex: 1,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface PreformattedGridState extends CrudModelPaginatorLaboratory<ConfigurationPreformattedResponse> {
    labId: number
    broadcastChannel: Nullable<BroadcastChannel>
}
export const initialPreformattedGridState =
    (): PreformattedGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.localSamples.preformatted',
        columnsDef: columnsDefTextPreformattedGrid(),
        datasource: new PaginatorLaboratoryDatasource(preformattedGridConfigurationServices, store.getters.labId),
        labId: store.getters.labId,
        broadcastChannel: null
    })
